import blog1 from "../img/blogs/leetcode.svg";
import blog2 from "../img/blogs/gfg.png";
import blog3 from "../img/blogs/hackerrank.svg";
import blog4 from "../img/blogs/codeg.png";
import blog5 from "../img/blogs/atcod.png";

export default [
  {
    id: 1,
    image: blog1,
    title: "LeetCode",
    rank: "solved-> 150+ Problems",
    prob: "Consistently participate in leet-contest",
    link: "https://leetcode.com/nabakumarsit2002/",
  },
  {
    id: 2,
    image: blog2,
    rank: "i. University Rank: 65, Top-5%",
    prob: "ii. Solved 200+ Problems ,",
    title: "Geeks for Geeks",
    link: "https://auth.geeksforgeeks.org/user/nabakumarsit2002/profile",
  },
  {
    id: 3,
    image: blog3,
    title: "Hackerrank",
    rank: "i. 5* in C++",
    achiev: "ii. 3* in problem solving",
    link: "https://www.hackerrank.com/nabakumarsit2002",
  },
  {
    id: 4,
    image: blog4,
    title: "CODECHEF",
    rank: "i. 750 global rank in August Cookoff",
    prob: "ii. 903 global rank in September Challenge",
    link: "https://www.codechef.com/users/chikku77777",
  },
  // {
  //   id: 5,
  //   image: blog5,
  //   title: "ATCODER",
  //   // rank: "-> '7457' rank in recent contest",
  //   link: "https://atcoder.jp/users/nabaAtcoder_79",
  // }
];
